class QuickAddModal extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector("dialog");
    this.content = this.querySelector(".dialog-content");
    this.onBodyClickHandler = this.onBodyClick.bind(this);
    Array.from(this.querySelectorAll(".dialog-close")).forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        this.close();
      });
    });
  }

  show(productUrl) {
    fetch(
      `${productUrl}${
        productUrl.indexOf("?") > -1 ? "&" : "?"
      }sections=modal-quick-add`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const result = JSON.parse(responseText);
        this.content.innerHTML = new DOMParser()
          .parseFromString(result["modal-quick-add"], "text/html")
          .querySelector(".shopify-section").innerHTML;
        this.open();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  open() {
    document.documentElement.classList.add("overflow-hidden");
    this.dialog.showModal();
    document.addEventListener("click", this.onBodyClickHandler);
    publish(PUB_SUB_EVENTS.dialogOpen);
  }

  close() {
    this.dialog.close();
    this.content.innerHTML = "";
    document.documentElement.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    document.removeEventListener("click", this.onBodyClickHandler);
    publish(PUB_SUB_EVENTS.dialogClose);
  }

  onBodyClick(event) {
    if (event.target !== this.dialog) return;
    this.close();
  }
}
customElements.define("quick-add-modal", QuickAddModal);
